
import React from 'react';
import { Badge } from "@/components/ui/badge";

interface BillingToggleProps {
  billingPeriod: 'monthly' | 'yearly';
  onToggle: (period: 'monthly' | 'yearly') => void;
}

const BillingToggle: React.FC<BillingToggleProps> = ({ billingPeriod, onToggle }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="relative bg-muted p-1 rounded-lg">
        <div className="flex">
          <button
            onClick={() => onToggle('monthly')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
              billingPeriod === 'monthly'
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => onToggle('yearly')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-all relative ${
              billingPeriod === 'yearly'
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Yearly
            <Badge 
              variant="secondary" 
              className="ml-2 bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 text-xs"
            >
              Save 17%
            </Badge>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingToggle;
